//Defininiciones de los recursos simples que se expresan con una sola linea

import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "./rpc";
import { rpcCrudService, cacheResource,bindResource, invalidateResource } from "kea-resource";

export const Rol = rpcCrudService<models.Rol>(rpcController("Rol"));
export const Vendedor = rpcCrudService<models.Vendedor>(rpcController("Vendedor"));
export const Estado = rpcCrudService<models.Estado>(rpcController("Estado"));
export const Municipio = rpcCrudService<models.MunicipioDTO>(rpcController("Municipio"));
export const TipoColonia = rpcCrudService<models.TipoColonia>(rpcController("TipoColonia"));
export const Ciudad = rpcCrudService<models.CiudadDTO>(rpcController("Ciudad"));
export const Caja = rpcCrudService<models.Caja, models.CajaDTO>(rpcController("Caja"));
export const ContenidoPaquete = rpcCrudService<models.ContenidoPaquete, models.ContenidoPaqueteDTO>(rpcController("ContenidoPaquete"));
export const Banco = rpcCrudService<models.Banco, models.BancoDTO>(rpcController("Banco"));
export const ContenidoSobre = rpcCrudService<models.ContenidoSobre, models.ContenidoSobreDTO>(rpcController("ContenidoSobre"));
export const Tarifa = rpcCrudService<models.Tarifa, models.TarifaDTO>(rpcController("Tarifa"));
export const RequerimientoAcuse = rpcCrudService<models.RequerimientoAcuse, models.RequerimientoAcuseDTO>(rpcController("RequerimientoAcuse"));
export const Ruta = rpcCrudService<models.Ruta, models.RutaDTO>(rpcController("Ruta"));
export const Segmento = rpcCrudService<models.Segmento, models.SegmentoDTO>(rpcController("Segmento"));
export const Cobrador = rpcCrudService<models.Cobrador, models.Cobrador>(rpcController("Cobrador"));
export const Articulo = rpcCrudService<models.Articulo, models.Articulo>(rpcController("Articulo"));
export const CamionEAD = rpcCrudService<models.CamionEAD, models.CamionEADDto>(rpcController("CamionEAD"));
export const TarifaPrecioZE = rpcCrudService<models.ZonaExtendidaTarifaPrecio, models.ZonaExtendidaTarifaPrecioDto>(rpcController("TarifaPrecioZE"));
export const UsuarioApi = rpcCrudService<models.UsuarioApi, models.UsuarioApiDto>(rpcController("UsuarioApi"));

export const VehiculoZE = rpcCrudService<models.VehiculoZE, models.VehiculoZEDto>(rpcController("VehiculoZE"));

const controller2 = rpcController("VehiculoZE");
const crud = rpcCrudService<models.VehiculoZE, models.VehiculoZEDto>(controller2);

const otros = cacheResource({
    QueryById: async (id:number): Promise<models.VehiculoZEDto[]> => await controller2("QueryById",{ id }),
    QueryByChoferId: async (id:number): Promise<models.VehiculoZEDto[]> => await controller2("QueryByChoferId",{ id }),
},
{ 
    QueryById: true,
    QueryByChoferId: true
})

export const VehiculoZE2 = bindResource({ ...crud, ...otros });

type MiResource = {
    get: () => void;
    update: () => void;
    delete: () => void;
    consultarListado: () => void;
}

const miResource: MiResource = {} as any;

const cacheRe = cacheResource(miResource, {
    get: true,
    consultarListado: true
}, {
        update: true,
        delete: true
    });


// WEBPACK FOOTER //
// ./app/resources/simple.ts